import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import phPigiBank from "../../../assets/images/blurred2/income/PigiBank.png";
import phHigh from "../../../assets/images/blurred2/levels/High.webp";
import phLow from "../../../assets/images/blurred2/levels/Low.webp";
import phMedium from "../../../assets/images/blurred2/levels/Middle.webp";
import HorizontalButton from "../../../components/HorizontalButton";
import ImageLoader from "../../../components/ImageLoader";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

const imagesToPreload = [
  "/imoji/Struggling.png",
  "/imoji/Head_with_tap.png",
  "/imoji/Confused.png",
  "/imoji/confort.png",
];

const buttonText = [
  t("income_level.low"),
  t("income_level.medium"),
  t("income_level.high"),
];

const data = [
  {
    image: addS3Url("/levels/Low.png"),
    placeHolderImage: phLow,
  },
  {
    image: addS3Url("/levels/Middle.png"),
    placeHolderImage: phMedium,
  },
  {
    image: addS3Url("/levels/High.png"),
    placeHolderImage: phHigh,
  },
];

const IncomeLevel = () => {
  const params = useParams();
  return (
    <MobileViewLayout>
      <div className="px-4 d-flex flex-column  justify-content-center align-items-center">
        <h2 className="text-black fw-bold text-center m-0 fs30 incomelevel-selection-heading">
          <Trans i18nKey={"income_level.question"} />
        </h2>
        <div className="income-level-img">
          <ImageLoader
            src={addS3Url("/income/PigiBank.jpg")}
            alt="income level"
            style={{ minHeight: "150px" }}
            className="w-100 object-fit-contain"
            placeHolderImage={phPigiBank}
          />
        </div>
        <div className="w-100 d-flex flex-column gap-1 py-4">
          {data.map((item, index) => (
            <HorizontalButton
              key={index}
              imagesToPreload={imagesToPreload}
              navigateTo={`/${params.gender}/situation`}
              label={buttonText[index]}
              className={"secondaryTextSize fs18 text-capitalize"}
              {...item}
            />
          ))}
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default IncomeLevel;
